const reportEvent = window.collectEvent || (() => { })
const PAGE_URL = location.href

// 自定义事件上报
export function collectEvent(eventName: string, eventParams: any = null) {
    eventParams = {
        ...eventParams,
    }
    reportEvent(eventName, eventParams);
}

// 普通接口监控
export function apiMonitor({
    monitorId,
    errorCode = 0,
    errorMsg = '',
    costTime = 0,
    extraInfo1 = '',
    extraInfo2 = '',
    extraInfo3 = ''
}) {
    collectEvent('wxdata_perf_monitor', {
        wxdata_perf_monitor_id: monitorId,
        wxdata_perf_error_code: errorCode || 0,
        wxdata_perf_error_msg: errorMsg || "none",
        wxdata_perf_cost_time: costTime,
        wxdata_perf_extra_info1: extraInfo1,
        wxdata_perf_extra_info2: extraInfo2,
        wxdata_perf_extra_info3: extraInfo3,
    })
}

// 分步接口监控
export function stepApiMonitor({
    monitorId,
    stepId = '',
    errorCode = 0,
    errorMsg = '',
    costTime = 0,
    extraInfo1 = '',
    extraInfo2 = '',
    extraInfo3 = ''
}) {
    collectEvent('wxdata_perf_monitor', {
        wxdata_perf_monitor_id: monitorId,
        wxdata_perf_step_id: stepId || '',
        wxdata_perf_error_code: errorCode || 0,
        wxdata_perf_error_msg: errorMsg || "none",
        wxdata_perf_cost_time: costTime,
        wxdata_perf_extra_info1: extraInfo1,
        wxdata_perf_extra_info2: extraInfo2,
        wxdata_perf_extra_info3: extraInfo3,
    })
}

// 前端报错上报
export function feErrorMonitor({
    id = '',
    msg = '',
}) {
    collectEvent('fe_error_monitor', {
        fe_error_monitor_id: id,
        fe_error_monitor_msg: msg || 'none',
    })
}

// 关键接口监控
export function criticalApiMonitor({
    id = '', // 接口id
    fullUrl = '', // 接口完整url
    method = 'get', // 请求方法
    reqData = null, // 请求data
    resData = null, // 响应data

    // 额外信息，比如文章id，资源id等
    articleId = '',
    resourceId = '',
    resourceType = '',
    projectId = '',
    projectName = '',
    title = '',
    text = ''
}: any) {
    const pathId = fullUrl?.split('?')[0].split('/').splice(-3).join('_')
    if (!id && !pathId) return
    if (!id) {
        id = pathId + '_' + (method || 'get').toLowerCase();
    }
    const MAX_TEXT = 100
    collectEvent('api_monitor', {
        api_monitor_id: id,
        api_monitor_full_url: fullUrl || 'unknown',
        api_monitor_req_data: reqData ? JSON.stringify(reqData) : "none",
        api_monitor_res_data: resData ? JSON.stringify(resData) : "none",
        api_monitor_res_code: resData?.code || resData?.err_code || 0,
        api_monitor_res_msg: resData?.message || resData?.err_msg || resData?.msg || 'none',
        api_monitor_page_url: PAGE_URL, // 当前页面路径
        api_monitor_extra_article_id: articleId,
        api_monitor_extra_resource_id: resourceId,
        api_monitor_extra_resource_type: resourceType,
        api_monitor_extra_project_id: projectId,
        api_monitor_extra_project_name: projectName.slice(0, MAX_TEXT),
        api_monitor_extra_title: title.slice(0, MAX_TEXT),
        api_monitor_extra_text: text.slice(0, MAX_TEXT),
    })
}